import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';


const PREFIX = 'InfoModal';

const classes = {
  dialogPaper: `${PREFIX}-dialogPaper`,
  dialogTitle: `${PREFIX}-dialogTitle`,
  dialogContentText: `${PREFIX}-dialogContentText`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(() =>
  ({
    [`& .${classes.dialogPaper}`]: {
      backgroundColor: '#2E3036',
      color: 'white'
    },

    [`& .${classes.dialogTitle}`]: {
      color: 'white',
    },

    [`& .${classes.dialogContentText}`]: {
      color: 'lightgray',
    }
  }));

const InfoModal: React.FC = () => {
  const [ open, setOpen ] = React.useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    (<Root>
      <div className='width-fit cursor-pointer' onClick={handleClickOpen}>
        <p className='font-weight-400 margin-0'>BITE GPT Instructions</p>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id='alert-dialog-title' className={classes.dialogTitle}>
          BIT GPT Instructions
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description' className={classes.dialogContentText}>
            <p>
              BITE GPT is a powerful analysis tool that integrates with OpenAI&apos;s GPT API.
              You can use BITE GPT to search the Web or search data within BITE.
              Please instruct the tool accordingly, so that your returns are accurate
            </p>
            For Example your can prompt GPT to do the Following:<br /><br />

            Search the Web for information for [XYZ]<br /><br />

            OR<br /><br />

            Search BITE for [XYZ]<br /><br />

            If searching against BITE, the tool will identify which data sets are returning data.<br /><br />


            <p>
              Additionally, you can do a deep-dive search against the US Customs and Border Protection (CBP) Customs Ruling Online Search System (CROSS)
              Please prompt BITE to &quot;Search CROSS for specific items of interest&quot;
            </p>

            <p>For further information please consult the BITE &quot;How To&quot; guides or email as us <a href='mailto:support@bitedata.io'>support@bitedata.io</a></p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className={classes.dialogTitle}>Close</Button>
        </DialogActions>
      </Dialog>
    </Root>)
  );
};
export default InfoModal;
